import React, { useState } from 'react';

import GeneralTab from './GeneralTab';
import DetailsTab from './DetailsTab';
import PersistentTab from './PersistentTab';

const EncoderTabWrapper = props => {
    const [tab, setTab] = useState('general')

    const handleTabChange = (tab, ev) => {
        ev && ev.preventDefault();
        setTab(tab)
    }

    const renderActiveTab = () => {
        switch (tab) {
            case 'general': return <GeneralTab {...props}/>;
            case 'details': return <DetailsTab {...props}/>;
            case 'persistent': return <PersistentTab {...props}/>;
        }
    }

    var at = tab;
    var { encoder } = props;
    return (<div className={encoder.online ? 'col-md-9' : 'col-md-12'}>
        <ul className="nav nav-tabs">
            <li className={at == 'general' ? 'active' : ''}><a href="#" onClick={handleTabChange.bind(null, 'general')}>General</a></li>
            <li className={at == 'details' ? 'active' : ''}><a href="#" onClick={handleTabChange.bind(null, 'details')}>Details</a></li>
            <li className={at == 'persistent' ? 'active' : ''}><a href="#" onClick={handleTabChange.bind(null, 'persistent')}>Live 24/7</a></li>
        </ul>
        {renderActiveTab()}
    </div>);


}

export default EncoderTabWrapper;
